export default __webpack_public_path__ + "static/media/2871.fae34730.png";